// Copyright 2021 Pangea Cyber Corporation
// Author: Pangea Cyber Corporation

import { useSbdArticlesData } from "./sbdArticlesData";

export const useSbdArticlesDataById = () => {
  const articlesDataById: any = {};

  const articlesData: any[] = useSbdArticlesData();

  for (const group of articlesData) {
    for (const value of group.nodes) {
      articlesDataById[value.path] = value;
    }
  }

  return articlesDataById;
};
